import React, { type ReactNode } from 'react';

import { HeaderWrapper, MetaText, PrimaryColumn, SecondaryColumn, Subtitle, Title, TitleWrapper } from './styles';

export interface HeaderProps {
    title: string;
    subtitle?: string;
    metaText?: string;
    children?: ReactNode;
    // TODO: This is a temporary prop until we can
    // better implement a `Header` following an
    // opened `Search` input.
    leadingSpace?: boolean;
}

export function Header({ title, subtitle, metaText, children, leadingSpace = false }: HeaderProps) {
    const metaTextMarkup = metaText ? <MetaText>{metaText}</MetaText> : null;
    const subtitleMarkup = subtitle ? <Subtitle>{subtitle}</Subtitle> : null;

    const childrenMarkup = children ? <SecondaryColumn>{children}</SecondaryColumn> : null;

    return (
        <HeaderWrapper $leadingSpace={leadingSpace}>
            <PrimaryColumn>
                <TitleWrapper>
                    <Title>{title}</Title>
                    {metaTextMarkup}
                </TitleWrapper>

                {subtitleMarkup}
            </PrimaryColumn>

            {childrenMarkup}
        </HeaderWrapper>
    );
}
